/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSelectionStart;
var _getGlobal = require("../../../../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var document = globalObject.document;
function getSelectionStart(o) {
  if (o.createTextRange && !globalObject.getSelection) {
    var r = document.selection.createRange().duplicate();
    r.moveEnd('character', o.value.length);
    if (r.text == '') return o.value.length;
    return o.value.lastIndexOf(r.text);
  }
  return o.selectionStart;
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/NumericInput/src/utils/get-selection-start.js
// module id = 253
// module chunks = 0